<script setup lang="ts">
import { RouterLink, useRouter } from "vue-router"
const router = useRouter()
defineProps<{ mobile?: 'show' | 'hide' }>()
</script>

<template>
  <component
    :is="$attrs.to ? RouterLink : 'button'"
    class="inline-flex transition hover:-translate-x-1"
    :class="[mobile == 'show' && 'md:hidden', mobile == 'hide' && 'max-md:hidden']"
    aria-label="Retour en arrière"
    v-bind="$attrs"
    @click="$attrs.to || router.back()"
  >
    <FeatherIcon
      name="arrow-left"
      class="size-[1em]"
      style="stroke-width: 2.4px"
    />
  </component>
</template>
